import React, { useEffect } from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { getPodcastPath } from '../../Routes/RouteNames'

interface SpotifyRedirectProps {}

const SpotifyRedirect: React.FC<SpotifyRedirectProps> = () => {
  const { podcastId } = useParams<{ podcastId: string }>()

  useEffect(() => {
    if (/^[0-9a-f]{24}$/i.test(podcastId)) {
      sessionStorage.setItem('spotifyFlowPodcastId', podcastId)
    }
  }, [podcastId])

  return <Redirect to={getPodcastPath(podcastId)} />
}

export default SpotifyRedirect
